import { z } from "zod";
export const JsonValueSchema = z.lazy(() => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(JsonValueSchema),
    z.record(z.string(), JsonValueSchema),
]));
export const PatchOperationKindSchema = z.enum(["set", "remove", "add"]);
export const PatchOperationSchema = z
    .object({
    op: PatchOperationKindSchema,
    path: z.string().min(1),
    value: JsonValueSchema.optional(),
})
    .strict();
export const PatchOperationListSchema = z.array(PatchOperationSchema);
//# sourceMappingURL=patch-operation.js.map